import script from "./NewAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewAccount.vue?vue&type=script&setup=true&lang=ts"

import "./NewAccount.vue?vue&type=style&index=0&id=6a14f385&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a14f385"]])

export default __exports__